const React = require('react');
const UserBadge = require('components/UserBadge');
const {
    SINGLE_LINE_INPUT_HEIGHT
} = require('hooks/useFormPrimitives/singleLineFieldStyles');

const BadgeFieldConfig = module.exports = {};

const internals = {};

BadgeFieldConfig.getOptionValue = (badge = {}) => badge.name;

BadgeFieldConfig.getOptionLabel = (badge = {}) => internals.getBadgeLabel(badge);

BadgeFieldConfig.renderOption = ({
    formProps,
    option: badge
}) => internals.renderBadgeOption({
    badge,
    badges: formProps.badges || []
});

BadgeFieldConfig.renderValue = ({
    formProps,
    selectedOption,
    value
}) => internals.renderBadgeValue({
    badge: selectedOption,
    badges: formProps.badges || [],
    value
});

BadgeFieldConfig.fieldStyles = `
    .MuiSelect-select.MuiInputBase-input {
        align-items: center;
        box-sizing: border-box;
        display: flex !important;
        min-height: 0 !important;
        overflow: hidden;
        padding-right: 40px !important;
    }

    .user-inputs-badge-value,
    .user-inputs-badge-option {
        align-items: center;
        display: flex;
        gap: 10px;
        justify-content: space-between;
        min-width: 0;
        width: 100%;
    }

    .user-inputs-badge-value {
        min-height: ${SINGLE_LINE_INPUT_HEIGHT}px;
    }

    .user-inputs-badge-value .badgeContainer,
    .user-inputs-badge-option .badgeContainer {
        height: 24px;
        width: 24px;
    }

    .user-inputs-badge-value .badgeContainer .innerIcon,
    .user-inputs-badge-option .badgeContainer .innerIcon {
        font-size: 12px;
    }
`;

internals.getBadgeLabel = (badge = {}) => badge.label || badge.name;

internals.renderBadge = ({
    badges,
    userType
}) => <UserBadge
    badges={badges}
    style={internals.badgeIconStyle}
    userType={userType}
/>;

internals.renderBadgeValue = ({
    badge,
    badges,
    value
}) => {

    const resolvedBadge = badge || badges.find((candidate) => candidate.name === value);

    if (!resolvedBadge) {
        return 'Select…';
    }

    return <span className='user-inputs-badge-value' style={internals.badgeValueStyle}>
        <span className='user-inputs-badge-label' style={internals.badgeLabelStyle}>{internals.getBadgeLabel(resolvedBadge)}</span>
        {internals.renderBadge({
            badges,
            userType: resolvedBadge.name
        })}
    </span>;
};

internals.renderBadgeOption = ({
    badge,
    badges
}) => <span className='user-inputs-badge-option' style={internals.badgeOptionStyle}>
    <span className='user-inputs-badge-label' style={internals.badgeLabelStyle}>{internals.getBadgeLabel(badge)}</span>
    {internals.renderBadge({
        badges,
        userType: badge.name
    })}
</span>;

internals.badgeValueStyle = {
    alignItems: 'center',
    display: 'flex',
    gap: 10,
    justifyContent: 'space-between',
    minHeight: SINGLE_LINE_INPUT_HEIGHT,
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    verticalAlign: 'middle',
    width: '100%'
};

internals.badgeOptionStyle = {
    alignItems: 'center',
    display: 'flex',
    gap: 10,
    justifyContent: 'space-between',
    minWidth: 0,
    width: '100%'
};

internals.badgeLabelStyle = {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};

internals.badgeIconStyle = {
    flex: '0 0 auto',
    height: 24,
    width: 24
};

BadgeFieldConfig.internals = internals;
